import { useState } from 'react';
import { Control, useController } from 'react-hook-form';

import { Zone } from 'types';

import { FormItem } from 'sections/EditForm';

import { CheckboxWithControl } from 'components/CheckboxWithControl';

import { useFormData } from './useFormData.hooks';

import * as S from './Checkboxes.styles';

type CheckboxesProps = {
  control: Control;
  zones?: Zone[];
};

const defaultProps: Partial<CheckboxesProps> = {};

export function Checkboxes(props: CheckboxesProps): React.ReactElement {
  const { control, zones } = { ...defaultProps, ...props };

  const { field } = useController({ control, name: 'zoneSpecial' });
  const [values, valuesSet] = useState(field.value || []);

  const data = useFormData(zones, valuesSet);

  const dataIntoCheckboxes = data?.map((item: FormItem, index: number) => (
    <CheckboxWithControl
      defaultChecked={item.defaultChecked}
      disabled={item.disabled}
      control={control}
      key={index}
      name="zoneSpecial"
      label={item.label!}
      onCheck={(e: React.ChangeEvent<HTMLInputElement>) => {
        const valuesCopy = [...values];
        valuesCopy[index] = e.target.checked ? { code: item.value } : null;

        field.onChange(valuesCopy.filter((valueItem: string) => valueItem));

        valuesSet(valuesCopy);
      }}
    />
  ));

  return <S.Container>{dataIntoCheckboxes}</S.Container>;
}
